import React from 'react';
import Modal from 'react-modal';
import WAIcon from 'react-icons/lib/fa/whatsapp'
import CloseIcon from 'react-icons/lib/fa/close'
 
const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};
 
class ModalTester extends React.Component {
  constructor() {
    super();
 
    this.state = {
      modalIsOpen: false
    };
 
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
 
  openModal() {
    this.setState({modalIsOpen: true});
  }
 
  afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.subtitle.style.color = 'black';
  }
 
  closeModal() {
    this.setState({modalIsOpen: false});
  }
 
  render() {
    return (
      <div className="comprar-modal">

        {this.props.vendido}

        <button 
          onClick={this.openModal}
          className={(this.props.vendido) ? 'btn disabled' : 'btn'}
          >
          {(this.props.vendido) ? 'Vendido' : '¿Cómo Comprar?'}

        </button>

        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
 
          <h2 ref={subtitle => this.subtitle = subtitle}>Gracias</h2>
          <p>Se tramita el pago mediante un depósito a la cuenta de <br /> 
          <b>Fiorella Pattoni Urbina</b> en dólares.</p> 
          <img className="bac-icon" src="https://www.baccredomatic.com/sites/all/themes/custom/foundation_bac/images/bacredomatic_logo.png" />
          <ul>
            <li><b>Cuenta BAC:</b> 922432570 </li>
            <li><b>SINPE:</b> 10200009224325704</li>
            <li><b>Cédula:</b> 1-1151-0626</li>
          </ul>
          <ul className="detalles">
           <li>* Especificar en detalle el nombre de la pieza que se quiere adquirir.</li>
           <li>* Enviar comprobante o pantallazo a <a href="mailto:info@fiorellapattoni.com">info@fiorellapattoni.com</a></li>
            <li>* Enviar su ubicación al Whatsapp junto con una dirección <br />de correo electrónico 
            para confirmar los detalles del envío.</li>
          </ul>          
          <i>Se ofrece la opción de pagar con datáfono junto con servicio de 
          mensajeria.</i>
          <div class="nav-content">
            <ul className="tabs">
              <li className="tab"><a href="whatsapp://send?abid=+50683075982"><WAIcon /> Whatsapp: 8307-5983</a></li>
              <li className="tab" ><a href="#" onClick={this.closeModal}><CloseIcon />Cerrar</a></li>
            </ul>
          </div>
          

          
        </Modal>
      </div>
    );
  }

}

export default ModalTester



// WEBPACK FOOTER //
// ./src/components/modal.js